'use strict'

import React from 'react'
import { Link } from 'react-router'
import IndexList from './IndexListComponent'
import Pager from './PagerComponent';
import $ from 'jquery'

require('styles/Index.less')

let config = require('config');

let logoGray        = require('../images/logo_gray.png')
let indexCloseSVG   = require('../images/index_close.svg')
var indexCloseStyle = { backgroundImage:'url(' + indexCloseSVG + ')' }

class Index extends React.Component
{
  constructor(props) {
    super(props)
    this.indexClose       = this.indexClose.bind(this)
    this.selectIndexClose = this.selectIndexClose.bind(this)
    this.selectCat        = this.selectCat.bind(this)
    this.event()
  }
  componentDidMount() {
    const { actions } = this.props
    actions.getTotalIndexPage();
    actions.getIndexPosts(1);
    $(window).scrollTop(0)
  }
  event() {
    var self = this
    $(document).on("click", "#index .pager_container a", function() {
      var id = parseInt($(this).data("page"))
      self.updateIndexPage(id)
      return false
    })
  }
  updateIndexPage(num) {
    const { actions, data } = this.props
    if (num != data.currentIndexPage) {
      actions.setCurrentIndex(num)
      if (data.selectCat) {
        actions.getIndexPostsByCat(num, data.selectCat)
      } else {
        actions.getIndexPosts(num)
      }
      $(window).scrollTop(0)
    }
  }
  selectCat(e)
  {
    const { actions, data } = this.props;
    var id = $(e.target).data('id')
    $('.index .cats li a').removeClass('current')
    $(e.target).addClass('current')
    actions.setCurrentIndex(1)
    if (id) {
      actions.getTotalIndexPage(id)
      actions.getIndexPostsByCat(1, id)
    } else {
      actions.getTotalIndexPage()
      actions.getIndexPosts(1)
    }
  }
  indexClose()
  {
    const { actions, data } = this.props;
    actions.indexClose()
    setTimeout(function() { $(window).scrollTop(data.scrollTop) }, 1)
  }
  selectIndexClose()
  {
    const { actions } = this.props;
    actions.indexClose()
    $(window).scrollTop(0)
  }
  render() {
    const { actions, data } = this.props;
    var self = this
    if (data.categories == null || data.indexPages == null) {
      return (<div/>)
    }
    var indexPostsNum = null
    if (data.indexPosts) {
      indexPostsNum = data.indexPosts.length
    }
    return (
      <div className='index'>
        <div className='header'>
          <a className='close' onClick={this.indexClose}><span style={indexCloseStyle}></span></a>
          <div className='logo'><img src={logoGray} alt={config.default.SITE_NAME} /></div>
        </div>
        <div className='inner'>
          <div className={'side ' + (indexPostsNum == 0 ? 'no_float':'') }>
            <ul className='cats'>
              <li><a onClick={this.selectCat} className='current'>All</a></li>
              { data.categories ?
                data.categories.map(function(cat, i)
                {
                  return (
                    <li key={i}><a onClick={self.selectCat} data-id={cat.id}>{ cat.name }</a></li>
                  )
                })
              :null }
            </ul>
            <ul className='pages'>
              { data.indexPages ?
                data.indexPages.map(function(page, i)
                {
                  if (page.acf.url)
                  {
                    var slug = page.acf.url.split("/")[3]
                    return (
                      <li key={i}><Link to={'/' + slug} onClick={self.selectIndexClose}>{ page.title.rendered }</Link></li>
                    )
                  }
                  else if (page.acf.blank_link_url)
                  {
                    return (
                      <li key={i}><a href={page.acf.blank_link_url} target="_blank">{ page.title.rendered }</a></li>
                    )
                  }
                })
              :null }
            </ul>
          </div>
          <div className='main'>
            { data.indexPosts != null ?
              <div className='list'>
                <IndexList posts={data.indexPosts} cat={data.categories} actions={actions} />
              </div>
            :null }
            { data.indexPosts != null ?
              <Pager type='index' actions={actions} totalpage={data.totalIndexPage} current={data.currentIndexPage} num={data.currentIndexPage} cat={data.selectCat} />
            :null }
          </div>
        </div>
        <footer className='ifooter'><div className='inner'>
          <p>system by <a href='http://everythingbuttheinternet.com/' target='_blank'>everything but the internet</a></p>
        </div></footer>
      </div>
    )
  }
}

Index.displayName = 'Index'

Index.propTypes = {}
Index.defaultProps = {}

export default Index



// WEBPACK FOOTER //
// ./src/components/IndexComponent.js